import { Flex, Space } from "antd"
import { Card, Text } from "components/common"
import { IconText } from "components/custom"
import { t } from "i18next"
import { useMemo } from "react"
import { getCompactCompositeString, renderUnorderedList } from "utils"
import styles from "../../index.module.less"
import cx from "clsx"
import CollapsableInsightCard from "../collapsableInsightCard/collapsableInsightCard"

export const ChatSummary = ({ summary, loading }) => {
  const summaryInfo = useMemo(
    () => [
      {
        icon: "MdEditNote",
        iconProps: { size: 16 },
        title: t("Next Steps"),
        content:
          summary?.nextSteps?.length > 0 ? (
            <div>{renderUnorderedList(summary?.nextSteps, "m-0")}</div>
          ) : (
            t("No clear next steps.")
          ),
      },
      {
        icon: "FiMessageCircle",
        title: t("Talking Points"),
        content:
          summary?.talkingPoints?.length > 0 ? (
            <div>{renderUnorderedList(summary?.talkingPoints, "m-0")}</div>
          ) : (
            t("No specific talking points.")
          ),
      },
    ],
    [summary]
  )

  return (
    <Flex vertical gap={28}>
      <Card loading={loading} className={cx(styles.basicCard, styles.summaryCard)} bodyStyle={{ padding: "16px" }}>
        <Space size={8} direction="vertical">
          <IconText
            titleProps={{ style: { color: "#0091BA" }, className: "semiBold" }}
            icon="MdAutoGraph"
            iconProps={{ color: "#0091BA" }}
            textType="secondary"
            title={t("Conversation Summary")}
          />
          <Text type="secondaryLight">{summary?.overallClientSummary}</Text>
          {summary?.projectsDiscussed?.length > 0 && (
            <Text>
              <Text type="secondary">{t("Project discussed:")}</Text>{" "}
              <strong>
                {getCompactCompositeString(
                  summary?.projectsDiscussed?.map(item => ({
                    name: item,
                  })),
                  2,
                  "#0091BA"
                )}
              </strong>
            </Text>
          )}
        </Space>
      </Card>
      {!!summary?.interactionDetails?.length > 0 && (
        <CollapsableInsightCard data={summary?.interactionDetails} loading={loading} />
      )}

      {summaryInfo?.map(item => (
        <Card loading={loading} className={styles.basicCard} bodyStyle={{ padding: "16px", background: "#FAFAFA" }}>
          <Flex vertical>
            <IconText
              iconProps={item?.iconProps}
              icon={item?.icon}
              titleProps={{ className: "semiBold" }}
              title={item?.title}
            />
            <div className={"gray-900"}>{item?.content}</div>
          </Flex>
        </Card>
      ))}
    </Flex>
  )
}
